import type { Placement, Responsive } from "@slot/presentation";

/**
 * The pirate captain behind the grid (the designer's "Pirate Rush 2x" Rive handoff, played as rive-spine's Spine
 * conversion), where the Cocos scene kept its inactive bear (`BackdropLayer/CharacterOverlayLayer`). His soles stand on
 * slot-bloody-teddy's bear spots, that layer's per-shape hosts in the same template (the user, 2026-10-23), in
 * composition-root units (y-down), with the hosts' scales. Portrait is the exception: this composition sits 100 units
 * higher than Bloody Teddy's (its offset −200, Bloody Teddy's −100), so Teddy's spot there (316.147, −451.385 at 0.7)
 * put his head above the screen; he stands smaller on the plank's right end instead, his boots behind its top edge.
 */
export const CAPTAIN_TUNING = {
  placement: {
    desktop: { x: 729.38, y: 507.765 },
    mobile: { x: 330, y: -345, scale: 0.5 },
    mobile_landscape: { x: 801.357, y: 522.709 },
  } as Responsive<Placement>,
  /**
   * Composition units per artboard pixel: his 1000 pixels from the hat's top to the soles stand as tall as the bear
   * (its 758.66 at the prefab's 0.748).
   */
  scale: 0.5675,
  /** How many of his idle loops (4 s each) play before he flips his coin once, counted again after every one-shot. */
  idleLoopsPerCoinFlip: 3,
  /** Engine seconds between two drawn frames at least. */
  frameSeconds: 1 / 30,
} as const;
